import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../Model/utility/utility.service';
import { DocuploadService } from '../../../Model/UploadDocument/docupload.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-upload-doc-form',
  standalone: true,
  imports: [CommonModule, NgSelectModule, RouterModule, DataTablesModule, FormsModule, LoaderComponent],
  templateUrl: './upload-doc-form.component.html',
  styleUrl: './upload-doc-form.component.scss'
})
export class UploadDocFormComponent {
  isDisabled: boolean = false;
  user = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  TableData: any[] = []
  EmployeeData: any[] = [];
  BranchMaster: any[] = [];
  EmployeeMaster: any[] = [];
  TypeData: any = null
  Filter = {
    SelectType: '',
    EmpMasterID: null,
    BranchID: null,
    LoginUserID: null
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private tooltip: TooltipService,
    private session: SessionService,
    private router: Router,
    private toast: ToastService,
    private comboload: ComboService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private route: ActivatedRoute,
    private docupload: DocuploadService,
    private download: DownloadSampleService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.TypeData = this.route.snapshot.data['type']; // Will either be 'IDCard' or 'Biodata'
    // this.Filter.EmpType = this.router.url.split('/')[3];
    if (this.TypeData === 'PF') {
      this.Filter.SelectType = 'Upload PF No.'
    } else if (this.TypeData === 'UAN') {
      this.Filter.SelectType = 'Upload UANNo.'
    } else if (this.TypeData === 'ESIC') {
      this.Filter.SelectType = 'Upload ESIC No.'
    } else if (this.TypeData === 'LIN') {
      this.Filter.SelectType = 'Upload LINNo.'
    }
    this.Filter.LoginUserID = this.user.UserId
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
    //this.SelectDate('RegistrationDate', null, null);
  }

  // ngAfterViewInit(): void {
  //   this.dtTrigger.next(null);
  // }

  // ngOnDestroy(): void {
  //   this.dtTrigger.unsubscribe();
  // }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      // 'BranchId': (Combotype == 'Client') ? this.Filter.BranchID : 0,
      // 'ClientId': (Combotype == 'Site') ? this.Filter.ClientID : 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        }
        // else if (Combotype == 'Client') {
        //   this.ClientMaster = response.ComboLoad;

        // } else if (Combotype == 'Site') {
        //   this.SiteMaster = response.ComboLoad;
        // }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }
  Validate(form: any) {
    this.TableData = [];
    if (form.valid) {
      this.getData();
    }
    else {
      form.submitted = true;
    }
  }
  getData() {
    this.isDisabled = true;
    this.TableData = Object.values([]);
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.destroy();
    //   this.dtTrigger.next(null);
    // });
    this.docupload.MasterDocument(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableData = Object.values(response.Table);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad2(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.docupload.DocFillCombo({
      'SelectType': Combotype,
      'BranchID': (Combotype == 'Reports EmpMaster') ? this.Filter.BranchID : 0,
      'UserID': this.Filter.LoginUserID
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Reports EmpMaster') {
          this.EmployeeMaster = response.Table;
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }
  exportToExcel() {
    this.isDisabled = true
    this.docupload.MasterDocument(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.EmployeeData = Object.values(response.Table);
          if (this.EmployeeData.length > 0) {
            this.download.exportToExcel(this.EmployeeData, "ExcelUpload_data");
            this.isDisabled = false
          }
          else {
            this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
            this.isDisabled = false
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  handleFileInput(event: any): void {
    if (this.TableData.length > 0) {
      const files: FileList = event.target.files;
      if (files && files.length > 0) {
        const file: File = files[0];
        const fileType: string | undefined = file.name.split('.').pop();
        if (fileType !== 'xlsx' && fileType !== 'xls') {
          this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
          return;
        }
        this.processExcelFile(file);
        event.target.value = '';
      }
    } else {
      this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
    }
  }

  // processExcelFile(file: File): void {
  //   const reader = new FileReader();
  //   reader.onload = (event) => {
  //     if (event && event.target && event.target.result) {
  //       const binaryString = event.target.result as string;
  //       const workbook = XLSX.read(binaryString, { type: 'binary' });
  //       const sheetName = 'Sheet1';
  //       if (!workbook.SheetNames.includes(sheetName)) {
  //         const errorMessage = 'Sheet1 not found in the uploaded file.';
  //         this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
  //         return;
  //       }
  //       const worksheet = workbook.Sheets[sheetName];
  //       const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
  //       const tableData = excelData.slice(1).map((row) => ({
  //         SrNo: row[0],
  //         EmpMasterID: row[1],
  //         EmpCode: row[2],
  //         Name: row[3],
  //         Column1: row[4],
  //       }));
  //       this.fillTableData(tableData);
  //     }
  //   };
  //   reader.readAsBinaryString(file);
  // }

  // // This method will fill your table with the data
  // fillTableData(data: any[]): void {
  //   // Assuming you have a tableData property in your class where the table data is stored
  //   this.TableData = data;
  //   console.log(this.TableData); // For debugging: Log the table data
  // }

  // processExcelFile(file: File): void {
  //   const reader = new FileReader();
  //   reader.onload = (event) => {
  //     if (event && event.target && event.target.result) {
  //       const binaryString = event.target.result as string;
  //       const workbook = XLSX.read(binaryString, { type: 'binary' });
  //       const sheetName = 'Sheet1';
  //       if (!workbook.SheetNames.includes(sheetName)) {
  //         const errorMessage = 'Sheet1 not found in the uploaded file.';
  //         this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
  //         return;
  //       }
  //       const worksheet = workbook.Sheets[sheetName];
  //       const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
  //       const updatedData = excelData.slice(1).map((row) => ({
  //         EmpMasterID: row[1],    
  //         Column1: row[4],      
  //       }));
  //       this.updateTableData(updatedData);
  //     }
  //   };
  //   reader.readAsBinaryString(file);
  // }
  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];

        // Check if Column1 exists in the header row
        const headers = excelData[0];
        const column1Index = headers.indexOf('Column1');

        if (column1Index === -1) {
          this.toast.show({ message: 'Column1 not found in the uploaded file.', type: toastTypeEnum.danger });
          return;
        }
        const updatedData = excelData.slice(1).map((row) => ({
          EmpMasterID: row[1],
          Column1: row[column1Index],
        }));

        this.updateTableData(updatedData);
      }
    };
    reader.readAsBinaryString(file);
  }

  updateTableData(updatedData: any[]): void {
    updatedData.forEach(updatedRow => {
      const matchingRow = this.TableData.find(row => row.EmpMasterID === updatedRow.EmpMasterID);

      if (matchingRow) {
        matchingRow.Column1 = updatedRow.Column1;
      }
    });
  }

}
